import { mergeStyles } from '@cian/utils';

import * as React from 'react';

import { getMlTopVasName, getTopVasName } from '../../../utils/name';

import { LittleAuctionIcon } from './icons/auction';
import { LittleColorizedIcon } from './icons/colorized';
import { LittlePayedIcon } from './icons/payed';
import { LittlePremiumIcon } from './icons/premium';
import { LittleTop3Icon } from './icons/top3';

import * as styles from './VasLabel.css';

export interface IVasLabelProps {
  /** Отсортированный список мнемоник VAS'ов объявления */
  vasList: string[];
  /** Переопределенный лейбл */
  label?: string;
  /** Наведен ли курсор на компонент VAS (флаг рендеринга состояния наведения) */
  isHovered?: boolean;
  /** Используется ли ранжированная выдача */
  isMLSearch?: boolean;
  /** Ставка в аукционе */
  auctionBet?: number;
  /** Стиль для лейбла */
  labelStyle?: string;
}

/**
 * Компонент для отображения примененных VAS в виде иконок примененных VAS и названия приоритетного VAS
 */
export class VasLabel extends React.Component<IVasLabelProps, object> {
  public render() {
    const { label, vasList, isHovered, isMLSearch, auctionBet, labelStyle } = this.props;

    const auctionBetText = !!auctionBet && ` + ${auctionBet} ₽`;
    const computedLabel = isMLSearch ? getMlTopVasName(vasList) : getTopVasName(vasList);

    return (
      <div className={styles['container']}>
        <div className={styles['icons']}>
          {vasList.map(vas => {
            return (
              <div className={styles['icon']} key={vas}>
                {this.getVasIcon(vas, isHovered)}
              </div>
            );
          })}
        </div>
        <div {...mergeStyles(styles['name'], isHovered && styles['name--hovered'], labelStyle)}>
          {label || computedLabel}
          {auctionBetText}
        </div>
      </div>
    );
  }

  private getVasIcon = (vas: string, isHovered?: boolean): React.ReactNode => {
    switch (vas) {
      case 'top3':
        return LittleTop3Icon(!!isHovered);
      case 'auction':
        return LittleAuctionIcon(!!isHovered);
      case 'premium':
        return LittlePremiumIcon(!!isHovered);
      case 'payed':
        return LittlePayedIcon(!!isHovered);
      case 'colorized':
        return LittleColorizedIcon(!!isHovered);
      default:
        return null;
    }
  };
}
